export const INITIAL_DATA_LOADED = '@app/initialData/loaded';
export const HOMEPAGE_DATA_LOADED = '@app/homepage/loaded';
export const SUGGESTED_SHOP_DETECTED = '@app/shop-detected';

export const initialDataLoadedAction = (currencies, mutations, featureSwitches) => ({
	type: INITIAL_DATA_LOADED,
	currencies,
	mutations,
	featureSwitches
});

export const homepageDataLoadedAction = (activeOrComingSoonRaffles, closedRaffles, carouselRaffles) => ({
	type: HOMEPAGE_DATA_LOADED,
	activeOrComingSoonRaffles,
	closedRaffles,
	carouselRaffles
});

export const shopDetectedAction = (shopId) => ({
	type: SUGGESTED_SHOP_DETECTED,
	shopId
});



// WEBPACK FOOTER //
// ./actions/CompoundFetchActions.js